/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `index` for the Caintra Connect frontend.
 * @module components/Events/EventListItem/index
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import VirtualEventCard from "./VirtualEventCard.jsx";
import BreakfastEventCard from "./BreakfastEventCard.jsx";
import RegistrationEventCard from "./RegistrationEventCard.jsx";
import BusinessEventCard from "./BusinessEventCard.jsx";

const EventListItem = ({ event, index, ...props }) => {
  const eventKey = event._id || index;

  if (event.tipoEvento === "VIRTUAL_EVENT") {
    return <VirtualEventCard event={event} eventKey={eventKey} {...props} />;
  }

  if (event.tipoEvento === "BREAKFAST_EVENT") {
    return <BreakfastEventCard event={event} eventKey={eventKey} {...props} />;
  }

  if (event.tipoEvento === "REGISTRATION_EVENT") {
    return (
      <RegistrationEventCard event={event} eventKey={eventKey} {...props} />
    );
  }

  return <BusinessEventCard event={event} eventKey={eventKey} {...props} />;
};

export default EventListItem;
